var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-card", { staticClass: "supsis-plan" }, [
    _vm.editableCard
      ? _c("div", { staticClass: "editable-form" }, [
          _c(
            "div",
            { staticClass: "form-button", on: { click: _vm.editPlan } },
            [_c("span", { staticClass: "material-icons" }, [_vm._v(" edit ")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-button delete-button",
              on: { click: _vm.deletePlan },
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" delete "),
              ]),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "p-card-header" }, [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "subtitle top",
            class: { setFont: _vm.plan.isPopular },
          },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.plan.title) + "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.plan.altTitle)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle price setFontPrice" }, [
          _c("div", [_vm._v(_vm._s(_vm.getPrice(_vm.plan)) + "₺")]),
          _vm._v(" "),
          _c("div", [
            _vm.getDiscount(_vm.plan) > _vm.getPrice(_vm.plan)
              ? _c("div", { staticClass: "discount" }, [
                  _vm._v(_vm._s(_vm.getDiscount(_vm.plan)) + "₺"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getDiscount(_vm.plan) < _vm.getPrice(_vm.plan) &&
            _vm.getPrice(_vm.plan) > _vm.plan.price
              ? _c("div", { staticClass: "oldprice" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.plan.type == "supsis"
                          ? _vm.details.agentCount + "x"
                          : ["whatsapp", "whatsapp-business"].includes(
                              _vm.plan.type
                            )
                          ? _vm.details.whatsappChannel + "x"
                          : ""
                      ) +
                      _vm._s(_vm.plan.price) +
                      "₺\n                    "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.plan.isPopular &&
        !_vm.isActive(
          _vm.plan,
          _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
        )
          ? _c("div", { staticClass: "popular" }, [
              _vm._v("\n                Popüler\n            "),
            ])
          : _vm._e(),
        _vm._v(" "),
        (
          _vm.wizard
            ? _vm.isSelected
            : !_vm.editableCard &&
              _vm.isActive(
                _vm.plan,
                _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
              )
        )
          ? _c("div", { staticClass: "popular" }, [
              _vm._v("\n                Mevcut Plan\n            "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.plan.isTrialPlan
          ? _c("div", { staticClass: "popular" }, [_vm._v("Deneme Paketi")])
          : _vm._e(),
        _vm._v(" "),
        _vm.editableCard
          ? _c("div", { staticClass: "popular" }, [
              _vm._v(_vm._s(_vm.plan.siteId ? "Özel Plan" : "Genel Plan")),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "p-card-content" }, [
      _vm.plan.features
        ? _c(
            "div",
            [
              _vm._l(_vm.plan.features, function (feature) {
                return _vm._l(
                  Object.keys(feature)
                    .filter(function (key) {
                      return typeof feature[key] == "number"
                        ? feature[key] !== 0
                        : true
                    })
                    .filter(function (key) {
                      return feature[key] !== false
                    })
                    .filter(function (key) {
                      return key !== "type"
                    }),
                  function (key) {
                    return _c(
                      "p",
                      { key: key },
                      [
                        _c("i", { staticClass: "fa fa-check" }),
                        _vm._v(" "),
                        key == "freeAgentCount"
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(feature[key]) +
                                  " Ücretsiz Temsilci"
                              ),
                            ]
                          : key == "agentCount"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0 ? "Sınırsız" : feature[key]
                                  ) +
                                  " Temsilci\n                    "
                              ),
                            ]
                          : key == "maxSessionCount"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0 ? "Sınırsız" : feature[key]
                                  ) +
                                  "\n                        Chatbot\n                    "
                              ),
                            ]
                          : key == "integrationCount"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0 ? "Sınırsız" : feature[key]
                                  ) +
                                  " Chatbot Entegrasyon\n                    "
                              ),
                            ]
                          : key == "storyCountLimit"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0 ? "Sınırsız" : feature[key]
                                  ) +
                                  " Chatbot Hikaye\n                    "
                              ),
                            ]
                          : key == "versionHistoryCount"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0 ? "Sınırsız" : feature[key]
                                  ) +
                                  " Chatbot Sürüm Geçmişi\n                    "
                              ),
                            ]
                          : key == "activeChatbotLimit"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0 ? "Sınırsız" : feature[key]
                                  ) +
                                  " Aktif Chatbot\n                    "
                              ),
                            ]
                          : key == "autoTranslation"
                          ? [_vm._v(" Otomatik Çeviri ")]
                          : key == "voiceCalling"
                          ? [_vm._v("Sesli Arama")]
                          : key == "videoCalling"
                          ? [_vm._v("Görüntülü Arama")]
                          : key == "dataProtect"
                          ? [_vm._v(" Veri Güvenliği ")]
                          : key == "accessAllAgent"
                          ? [_vm._v(" Tüm Temsilciler için Erişim ")]
                          : key == "notAdditionalPrice"
                          ? [_vm._v(" Ek Maliyet Gerektirmez ")]
                          : key == "report"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] == "basic-report"
                                      ? "Normal Raporlama"
                                      : "Detaylı Raporlama"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          : key == "visitorTracking"
                          ? [_vm._v("Anlık Ziyaretci Takibi")]
                          : key == "fileAndVoiceMessage"
                          ? [_vm._v("Dosya ve Ses Kaydı Paylaşımı")]
                          : key == "teamChatEntegration"
                          ? [_vm._v("Takım Konuşması Entegrasyonu")]
                          : key == "support"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] == "basic-support"
                                      ? "Destek"
                                      : "7/24 Destek"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          : key == "softwareSupport"
                          ? [_vm._v("Yazılım Desteği")]
                          : key == "dedicatedCustomerSupport"
                          ? [_vm._v("Özel Müşteri Desteği")]
                          : key == "chatAndNotification"
                          ? [_vm._v("Chat ve Bildirimler")]
                          : key == "chatballonCustomization"
                          ? [_vm._v("Sohbet Balonu Özeleştirme")]
                          : key == "removeSupsisLogo"
                          ? [_vm._v(" Supsis Logo Kaldırma")]
                          : key == "databaseConnection"
                          ? [_vm._v("İzole Veritabanı Bağlantısı")]
                          : key == "singlePanelAccess"
                          ? [_vm._v("Tek Panelden Yönetim")]
                          : key == "ticketSystem"
                          ? [_vm._v("Ticket Sistemi")]
                          : key == "whatsappEntegration"
                          ? [_vm._v("Whatsapp Entegrasyonu")]
                          : key == "instagramEntegration"
                          ? [_vm._v("Instagram Entegrasyonu")]
                          : key == "messengerEntegration"
                          ? [_vm._v("Messenger Entegrasyonu")]
                          : key == "telegramEntegration"
                          ? [_vm._v("Telegram Entegrasyonu")]
                          : key == "maxTriggerCount"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0 ? "Sınırsız" : feature[key]
                                  ) +
                                  "\n                        Akıllı Tetikleyici\n                    "
                              ),
                            ]
                          : key == "brodcastPerMessage"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0
                                      ? "Mesaj Başına Ek Ücret"
                                      : feature[key] + "₺ Toplu Mesaj Başına"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          : key == "bulkMessageSending"
                          ? [_vm._v("Toplu Mesaj Gönderme")]
                          : key == "messageUnregisteredNumbers"
                          ? [
                              _vm._v(
                                "\n                        Kayıtlı Olmayan Numaralara Mesajlaşma\n                    "
                              ),
                            ]
                          : key == "personalizedBroadcastMessage"
                          ? [
                              _vm._v(
                                "\n                        Kişiselleştirilmiş Yayın Mesajı\n                    "
                              ),
                            ]
                          : key == "chatbotButtonActivity"
                          ? [_vm._v("Otomatik Düğme / Chatbot")]
                          : key == "chatbotEntergration"
                          ? [_vm._v("Chatbot Entegrasyonu")]
                          : key == "controlWhatsapp"
                          ? [_vm._v("Whatsapp Yönetimi")]
                          : key == "visitorStartChat"
                          ? [_vm._v("Ziyaretci Chat Başlatma")]
                          : key == "editableChatbotMessage"
                          ? [
                              _vm._v(
                                "\n                        Kişileştirilmiş Asistan / Chatbot Mesaj\n                    "
                              ),
                            ]
                          : key == "mailEntegration"
                          ? [_vm._v("Mail Entegrasyonu")]
                          : key == "smsEntegration"
                          ? [_vm._v("SMS Entegrasyonu")]
                          : key == "chatArchiveTime"
                          ? [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    feature[key] < 0
                                      ? "Sınırsız"
                                      : feature[key] / 7 + " Hafta"
                                  ) +
                                  "  Arşiv\n                    "
                              ),
                            ]
                          : key == "readyContents"
                          ? [_vm._v(" Hazır İçerikler ")]
                          : key == "allEntegrations"
                          ? [_vm._v(" Entegrasyonlar ")]
                          : _vm._e(),
                      ],
                      2
                    )
                  }
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    !_vm.editableCard
      ? _c(
          "button",
          {
            staticClass: "btn",
            class: {
              passive: _vm.wizard
                ? _vm.isSelected
                : _vm.isUpgrade(_vm.plan) ||
                  _vm.isActive(
                    _vm.plan,
                    _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                  ),
            },
            attrs: {
              disabled: _vm.wizard ? _vm.isSelected : _vm.isUpgrade(_vm.plan),
            },
            on: {
              click: function ($event) {
                _vm.wizard
                  ? _vm.subscribe(_vm.plan)
                  : _vm.isActive(
                      _vm.plan,
                      _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                    ) &&
                    _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type].plan
                      .enabled
                  ? _vm.unsubscribe(_vm.plan)
                  : _vm.isActive(
                      _vm.plan,
                      _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                    ) &&
                    !_vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                      .plan.enabled
                  ? _vm.subscribe(_vm.plan)
                  : _vm.subscribe(_vm.plan)
              },
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.wizard
                    ? _vm.isSelected
                      ? "Aktif Plan"
                      : "Plan Seç"
                    : _vm.isUpgrade(_vm.plan)
                    ? "Geçiş Yapılamaz"
                    : _vm.isActive(
                        _vm.plan,
                        _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                      ) &&
                      _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                        .plan.enabled
                    ? "İptal Et"
                    : _vm.isActive(
                        _vm.plan,
                        _vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                      ) &&
                      !_vm.currentPlans[_vm.plan.dynamicType || _vm.plan.type]
                        .plan.enabled
                    ? "Devam Et"
                    : "Plan Seç"
                ) +
                "\n    "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }